export default {
  SERVER_ENDPOINT: import.meta.env.VITE_SERVER_ENDPOINT,
};
